import React from "react";
import { WORK_TIMEZONE_OPTIONS } from "../../utils/workTimezonePreference";

export default function WorkTimezoneSelect({
  value,
  onChange,
  disabled = false,
  className = "",
  compact = false,
}) {
  const selected = WORK_TIMEZONE_OPTIONS.find((opt) => opt.id === value);

  return (
    <select
      className={className}
      aria-label="Work timezone"
      title={
        selected
          ? `Work timezone: ${selected.value}`
          : "Work timezone used for login/logout day and hours"
      }
      value={value || ""}
      disabled={disabled}
      onChange={(e) => {
        if (typeof onChange === "function") onChange(e.target.value);
      }}
    >
      {!value ? (
        <option value="" disabled>
          {compact ? "TZ" : "Timezone"}
        </option>
      ) : null}
      {WORK_TIMEZONE_OPTIONS.map((opt) => (
        <option key={opt.id} value={opt.id}>
          {compact ? opt.shortLabel || opt.value : opt.value}
        </option>
      ))}
    </select>
  );
}
